.container {
  /* Justering på spacing slik at fokusmarkering osv. ikke skjules ved overflow */
  --dds-drawer-content-container-padding: var(--dds-spacing-x0-25);
  --dds-drawer-container-padding: var(--dds-spacing-x1)
    calc(var(--dds-spacing-x1) - var(--dds-drawer-content-container-padding))
    calc(var(--dds-spacing-x1) - var(--dds-drawer-content-container-padding))
    calc(var(--dds-spacing-x1-5) - var(--dds-drawer-content-container-padding));

  z-index: var(--dds-zindex-drawer);

  @media (prefers-reduced-motion: no-preference) {
    transition: transform var(--dds-motion-surface);
  }
}

.container--left {
  left: 0;
}

.container--left-opened {
  transform: translate(0px);
}

.container--left-closed {
  transform: translate(-100%);
}

.container--right {
  right: 0;
}

.container--right-opened {
  transform: translate(0px);
}

.container--right-closed {
  transform: translate(100%);
}

.content-container {
  /* Spacing slik at fokusmarkering osv. ikke skjules ved overflow */
  padding: var(--dds-drawer-content-container-padding);
}

.drawer-header {
  padding-bottom: calc(
    var(--dds-spacing-x0-75) - var(--dds-drawer-content-container-padding)
  );
  z-index: 1;
}

.button--close {
  margin-left: auto;
  margin-top: calc(-1 * var(--dds-spacing-x0-125));
}
